import { MouseEvent, useCallback, useState } from 'react';
import { find } from 'lodash-es';

import { IParticipant } from 'src/interfaces/Participant';

export function useParticipantEditorModal(participants: IParticipant[]) {
  const [open, setOpen] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState<IParticipant | undefined>();

  const openEditor = useCallback(
    (id?: string, e?: MouseEvent<unknown>) => {
      e?.stopPropagation();
      setSelectedParticipant(id ? find(participants, { id }) : undefined);
      setOpen(true);
    },
    [participants],
  );

  const closeEditor = useCallback(() => {
    setSelectedParticipant(undefined);
    setOpen(false);
  }, []);

  return {
    open,
    selectedParticipant,
    openEditor,
    closeEditor,
  };
}
